import { render, staticRenderFns } from "./UpdateVehicleDetail.vue?vue&type=template&id=5fde89d5&"
import script from "./UpdateVehicleDetail.vue?vue&type=script&lang=js&"
export * from "./UpdateVehicleDetail.vue?vue&type=script&lang=js&"
import style0 from "./UpdateVehicleDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports